import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-482d2fcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "product_item" }
const _hoisted_2 = { class: "asset" }
const _hoisted_3 = {
  key: 0,
  class: "toggle"
}
const _hoisted_4 = { class: "thumbnail_content" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "introduce_content" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "sub_title" }

import { inject, onMounted, ref, computed } from "vue";
import provide_key from "@/constant/provide_key";
import PopupView from "./PopupView.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductItem',
  props: ["productInfo", "reverse"],
  setup(__props) {

const props = __props

const shrink: boolean | undefined = inject(provide_key.SHRINK);

const direction = computed(() => props.reverse ? 'row' : 'row-reverse')

const visible = ref(false)

const onVisible = () => visible.value = true

const currentThumbnail = ref(props.productInfo.thumbnailLeft)

const onLeft = () => currentThumbnail.value = props.productInfo.thumbnailLeft

const onRight = () => currentThumbnail.value = props.productInfo.thumbnailRight

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _directive_fadeIn = _resolveDirective("fadeIn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "asset_content",
        style: _normalizeStyle({ 'flex-direction': _unref(shrink) ? 'column' : direction.value})
      }, [
        _createElementVNode("div", {
          class: "thunbnail",
          style: _normalizeStyle({'flex': _unref(shrink) ? 'none' : '1'})
        }, [
          (__props.productInfo.thumbnailRight)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_van_icon, {
                  name: "arrow-left",
                  class: "icon",
                  onClick: onLeft,
                  color: currentThumbnail.value == __props.productInfo.thumbnailLeft ? '#9f9f9f' : '#333'
                }, null, 8, ["color"]),
                _createVNode(_component_van_icon, {
                  name: "arrow",
                  class: "icon",
                  onClick: onRight,
                  color: currentThumbnail.value == __props.productInfo.thumbnailRight ? '#9f9f9f' : '#333'
                }, null, 8, ["color"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: currentThumbnail.value,
              alt: ""
            }, null, 8, _hoisted_5)
          ])
        ], 4),
        _createElementVNode("div", {
          class: "introduce",
          style: _normalizeStyle({'width': _unref(shrink) ? '65vw' : 'auto'})
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(__props.productInfo.title), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(__props.productInfo.subTitle), 1),
            _createElementVNode("div", {
              class: "button",
              onClick: onVisible
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("product.BUTTON")), 1)
            ]),
            _createVNode(PopupView, {
              visible: visible.value,
              "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
              productInfo: __props.productInfo
            }, null, 8, ["visible", "productInfo"])
          ])
        ], 4)
      ], 4)), [
        [_directive_fadeIn]
      ])
    ])
  ]))
}
}

})